<template>
    <div class="account-list md-layout md-alignment-top-center">
    <md-progress-bar v-show="archivedAccountsLoading" class="md-accent md-layout-item md-size-100" md-mode="indeterminate"></md-progress-bar>
    <account-table :accounts-loading="archivedAccountsLoading" :accounts="archivedAccounts"></account-table>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { db } from '@/db';
import AccountTable from '@/components/AccountTable.vue';
export default {
  name: "accountList",
  components: {AccountTable},
  computed: {
    ...mapGetters(['archivedAccounts', 'archivedAccountsLoading']),
  },
  mounted() {
      this.$store.dispatch('loadArchivedAccounts', {ref: db.ref('bankAccounts').orderByChild('archived').equalTo(true)});
  }
}
</script>
